import { Controller } from "@hotwired/stimulus"

// My Shelf's workbench corkboard: at most `rows` rows, the last two slots
// always Start a build and "+N more". Counts how many pins fit across, shows
// as many builds as leave room for the two notes, and counts the rest in
// "+N more". Without it every rendered pin shows, with the server's own count.
export default class extends Controller {
  static targets = ["pin", "more", "count"]
  static values = { total: Number, rows: { type: Number, default: 2 } }

  connect() {
    this.observer = new ResizeObserver(() => {
      if (this.element.clientWidth === this.width) return
      this.width = this.element.clientWidth
      this.fit()
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  fit() {
    const pins = this.pinTargets
    if (!pins.length) return
    pins.forEach(pin => { pin.hidden = false })
    const gap = parseFloat(getComputedStyle(this.element).columnGap) || 0
    // (a phone sizes pins to exactly a third of the row, so allow for rounding)
    const across = Math.max(1, Math.floor((this.element.clientWidth + gap) / (pins[0].getBoundingClientRect().width + gap) + 0.02))
    const slots = across * this.rowsValue
    // Everything fits beside Start a build: show it all. Otherwise leave the
    // last two slots for Start a build and "+N more".
    const shown = this.totalValue + 1 <= slots ? pins.length : Math.max(0, Math.min(pins.length, slots - 2))
    pins.forEach((pin, i) => { pin.hidden = i >= shown })
    const rest = this.totalValue - shown
    if (this.hasMoreTarget) this.moreTarget.hidden = rest <= 0
    if (this.hasCountTarget) this.countTarget.textContent = rest
  }
}
